import { render } from "./PhenotypeView.vue?vue&type=template&id=a9f629aa&scoped=true"
import script from "./PhenotypeView.vue?vue&type=script&lang=js"
export * from "./PhenotypeView.vue?vue&type=script&lang=js"

import "./PhenotypeView.vue?vue&type=style&index=0&id=a9f629aa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9f629aa"]])

export default __exports__